import React from 'react'
import TextControl from './../TextControl'
import DateIcon from './DateIconSvg'

export default props => <TextControl
  {...props}
  disabled
  type="date"
  icon={<DateIcon />}
/>


// WEBPACK FOOTER //
// ./src/modules/DateControl/DateControl.js